/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Mode_DenoiseInputs */

const cs_property_ai_mode_denoise = /** @type {(inputs: Property_Ai_Mode_DenoiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstranění šumu`)
};

const en_property_ai_mode_denoise = /** @type {(inputs: Property_Ai_Mode_DenoiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denoise`)
};

/**
* | output |
* | --- |
* | "Denoise" |
*
* @param {Property_Ai_Mode_DenoiseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_mode_denoise = /** @type {((inputs?: Property_Ai_Mode_DenoiseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Mode_DenoiseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_mode_denoise(inputs)
	return cs_property_ai_mode_denoise(inputs)
});